// import "../../styling/style.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Formik, FormikErrors } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { getBase64GeneratePdfSuratPersetujuanMaster } from "../../api/GenerateBase64PdfSuratPersetujuanMaster";
import AutocompleteDisabledComponent from "../../components/autocompletedisabled/autocomplete-disabled-mui";
import CommentDisabledComponent from "../../components/commentdisabled/comment-disabled-mui";
import CRRNumberField from "../../components/crrnumberfield/crr-number-field-mui";
import ConfirmationDialog from "../../components/dialog/simple-alert";
import DropdownlistDisabledComponent from "../../components/dropdownlistdisabled/dropdownlist-disabled-mui";
import Feedback from "../../components/feedback/feedback";
import Loading from "../../components/loading/loading";
import TextAreaDisabledComponent from "../../components/textareadisabled/textarea-disabled-mui";
import TextFieldDateComponent from "../../components/textfielddate/textfield-date-mui";
import TextFieldDateDisabledComponent from "../../components/textfielddatedisabled/textfield-date-disabled-mui";
import TextFieldDisabledComponent from "../../components/textfielddisabled/textfield-disabled-mui";
import TextFieldMultiDisabledComponent from "../../components/textfieldmultidisabled/textfield-multi-disabled-mui";
import UploadMultipleFileComponent from "../../components/uploadmultiplefile/UploadMultipleFile";
import { IDataComment } from "../../interfaces/IDataComment";
import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { IForm } from "../../interfaces/IForm";
import { TransactionHistoryModal } from "../../shared/Components/TransactionHistoryModal";
import { DocumentType, RequestStatus, RequestType } from "../../shared/Enum";
import {
  FilterDistinctByIdAndSort,
  RemoveDateFromFileName,
} from "../../shared/functions";

import { selectUserProfile, selectUserRole } from "../../store/auth/selector";
import { homeStyle } from "../../styles/container/home";
import {
  downloadSingleFile,
  editFormFinishCL,
  getListAreaLocation,
  getListDocumentType,
  getListRequestType,
  getSharepointToken,
  getSingleDataRequest,
  resendEmailFinishedForm,
} from "./api-endpoint/callApi";

const getBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    reader.addEventListener("error", (error) => {
      reject(error);
    });
    reader.readAsDataURL(file);
  });

function EditFinishCL() {
  const { id } = useParams();
  const [listDocumentType, setListDocumentType] = useState([]);
  const [listAreaLocation, setListAreaLocation] = useState([]);
  const [listRequestType, setListRequestType] = useState([]);
  const [validationDocumentType, setValidationDocumentType] = useState(
    DocumentType.toId(DocumentType.Softcopy)
  );
  const [validationDateOfPower, setValidationDateOfPower] = useState("");
  const [validationDateGrantOfPower, setValidationDateGrantOfPower] =
    useState("");
  const [validationRequestType, setValidationRequestType] = useState(
    RequestType.toId(RequestType.SuratKuasa)
  );
  const [validationSignerAndLeader, setValidationSignerAndLeader] =
    useState(false);
  const [sharepoint, setSharepoint] = useState<any>({ token: "", expToken: 0 });
  const [errorUpload, setErrorUpload] = useState("");
  const [errorUploadRealizationDM, setErrorUploadRealizationDM] = useState("");
  const [validationNeedRealization, setValidationNeedRealization] =
    useState(false);

  const [globalDocumentType, setGlobalDocumentType] = useState("");
  const [formData, setFormData] = useState<IForm | undefined>();
  const [openConfirmationSubmit, setOpenConfirmationSubmit] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [requestDate, setRequestDate] = useState("");
  const [requestStatusID, setRequestStatusID] = useState("");
  const [requestStatusName, setRequestStatusName] = useState("");
  const [enableNoteGrantDate, setEnableNoteGrantDate] = useState(false);

  const [crrNumber, setCrrNumber] = useState("");

  const [saveAndSendConfirmationSubmit, setSaveAndSendConfirmationSubmit] =
    useState(false);
  const [saveAndSendConfirmationValue, setSaveAndSendConfirmationValue] =
    useState("");

  const [resendConfirmationSubmit, setResendConfirmationSubmit] =
    useState(false);
  const [resendConfirmationValue, setResendConfirmationValue] = useState("");

  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Unggah Draft Final / Upload Final Draft*",
      fileType: "Draft Final",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [uploadRealizationDM, setUploadRealizationDM] = useState<
    NewIDataUploadItem[]
  >([
    {
      title:
        "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
      fileType: "Master Document Realization",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);

  const [fileSuratPersetujuanGeneratePdf, setFileSuratPersetujuanGeneratePdf] =
    useState<NewIDataUploadItem[]>([
      {
        title: "",
        fileType: "Surat Persetujuan Penggunaan Master Dokumen",
        files: [
          {
            documentID: "",
            fileBase64: "",
            fileName: "",
            folderName: "",
          },
        ],
      },
    ]);

  const [actionButtonClick, setActionButtonClick] = useState("");
  const [dataCommentEndUser, setDataCommentEndUser] = useState<IDataComment[]>(
    []
  );
  const [dataCommentCL, setDataCommentCL] = useState<IDataComment[]>([]);
  const [requestNumber, setRequestNumber] = useState("");

  const [valueTab, setValueTab] = useState(0);
  const getRole = useSelector(selectUserRole);
  const profile = useSelector(selectUserProfile);
  const today = new Date();
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const Navigate = useNavigate();

  const initialValues: IForm = {
    startDatePeriod: "",
    endDatePeriod: "",
    binusianID: profile.BinusianId,
    email: "",
    binusianName: "",
    businessUnit: "",
    department: "",
    title: "",
    buLeader: "",
    extension: "",
    documentType: DocumentType.toId(DocumentType.Softcopy),
    requestType: RequestType.toId(RequestType.SuratKuasa),
    dateOfPower: "",
    dateGrantOfPower: "",
    clNote: "",
    lrNote: "",
    signer: null,
    titleAgreement: "",
    area: "Anggrek",
    address: "",
    counterPart: "",
    requestDate: "",
    substitutor: null,
    delegatee: null,
    noPowerAttorney: "",
    noSubstitutor: "",
  };

  const getDocumentType = async () => {
    try {
      // get all data for table list User
      const ltDocumentType = await getListDocumentType();
      // console.log(ltDocumentType);
      setListDocumentType(ltDocumentType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getAreaLocation = async () => {
    try {
      // get all data for table list User
      const tempDataAreaLocation: any = [];
      const ltAreaLocation = await getListAreaLocation();
      const jsonParse = JSON.parse(ltAreaLocation);
      jsonParse.data.forEach((datas: any) => {
        tempDataAreaLocation.push({
          label: datas.locationHierarcy.text,
          value: datas.locationHierarcy.id,
        });
      });
      const distinctLocation = FilterDistinctByIdAndSort(tempDataAreaLocation);
      setListAreaLocation(distinctLocation);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  const getRequestType = async () => {
    try {
      // get all data for table list User
      const msRequestType = await getListRequestType();
      setListRequestType(msRequestType);
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  /* eslint-disable unicorn/consistent-function-scoping */
  function transformSingleData(data): any[] {
    const categoryMap = {
      "Draft Final": "Unggah Draft Final / Upload Final Draft*",
      "Approval BU Leader": "Approval BU Leader / BU Leader Approval*",
      "Partner Request": "Unggah Permohonan Partner / Upload Partner Request",
      "Master Document Realization":
        "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
    };
    const categoryKey = {
      "Draft Final": 1,
      "Approval BU Leader": 2,
      "Partner Request": 3,
      "Master Document Realization": 4,
    };
    const orderedCategoryKeys = Object.keys(categoryKey).sort(
      (a, b) => categoryKey[a] - categoryKey[b]
    );

    const groupedData = data.reduce((acc, item) => {
      const { category, documentID, documentName, link } = item;
      const newTitleName = categoryMap[category] || category;
      const newCategory = categoryKey[category]
        ? category
        : categoryKey[category];
      acc[newCategory] = acc[newCategory] || {
        title: newTitleName,
        fileType: category,
        files: [],
      };
      acc[newCategory].files.push({
        documentID,
        fileBase64: "",
        fileName: documentName,
        folderName: link,
      });
      return acc;
    }, {});

    return orderedCategoryKeys
      .map((key) => groupedData[key])
      .filter((item) => item !== undefined);
  }
  /* eslint-enable unicorn/consistent-function-scoping */

  // eslint-disable-next-line consistent-return
  const getSingleData = async () => {
    try {
      // get all data for table list User
      const getSingleRequest = await getSingleDataRequest(id);
      setRequestStatusName(getSingleRequest.trRequest.requestStatusName);
      setCrrNumber(getSingleRequest.trRequest.noCRR);

      // Validation Access Page
      if (
        (getRole.roleId != "RL230000003" &&
          getRole.roleId != "RL230000001" &&
          getSingleRequest.trRequest.requestStatusID !=
            RequestType.toId(RequestType.DokumenMaster)) ||
        (getSingleRequest.trRequest.requestStatusID !=
          RequestStatus.toId(RequestStatus.Finished) &&
          getSingleRequest.trRequest.requestStatusID !=
            RequestStatus.toId(RequestStatus.FinishedRevised))
      ) {
        Navigate("/");
      }

      setRequestNumber(getSingleRequest.trRequest.requestNumber);

      // profile
      initialValues.binusianName = getSingleRequest.trRequest.binusianName;
      initialValues.businessUnit = getSingleRequest.trRequest.businessUnit;
      initialValues.department = getSingleRequest.trRequest.department;
      initialValues.title = getSingleRequest.trRequest.title;
      initialValues.buLeader = getSingleRequest.trRequest.buLeader;
      initialValues.extension = getSingleRequest.trRequest.ext;
      // case Soft Copy
      setRequestDate(
        moment(getSingleRequest.trRequest.requestDate).format("DD MMMM YYYY")
      );
      initialValues.dateOfPower = moment(
        getSingleRequest.trRequest.poaDate
      ).format("YYYY-MM-DD");
      setValidationDateOfPower(getSingleRequest.trRequest.poaDate);
      if (getSingleRequest.trRequest.dateGrantOfPower !== null) {
        initialValues.dateGrantOfPower = moment(
          getSingleRequest.trRequest.dateGrantOfPower
        ).format("YYYY-MM-DD");
        setValidationDateGrantOfPower(
          getSingleRequest.trRequest.dateGrantOfPower
        );
        initialValues.clNote = getSingleRequest.trRequest.clNote;
        initialValues.lrNote = getSingleRequest.trRequest.lrNote;
        // if (
        //   getSingleRequest.trRequest.dateGrantOfPower <=
        //   getSingleRequest.trRequest.poaDate
        // ) {
        //   setEnableNoteGrantDate(false);
        // } else {
        //   setEnableNoteGrantDate(true);
        // }
      }
      initialValues.signer = {
        binusianIDEmail: getSingleRequest.trRequest.signer.split("#")[0],
        name: getSingleRequest.trRequest.signer.split("#")[1],
      };
      const newSK = getSingleRequest?.trRequest?.needSK?.toString() ?? "false";
      initialValues.needSK = newSK;
      if (
        // getSingleRequest.trRequest.signer.split("#")[0].split("~")[1].trim() ==
        // getSingleRequest.trRequest.buLeaderBinusianID.trim()
        newSK == "false"
      ) {
        setValidationSignerAndLeader(true);
      }
      initialValues.titleAgreement = getSingleRequest.trRequest.titleAgreement;
      initialValues.counterPart = getSingleRequest.trRequest.counterpart;
      initialValues.documentType = getSingleRequest.trRequest.documentTypeID;
      if (getSingleRequest.trRequest.startMasterUsePeriod !== null) {
        initialValues.startDatePeriod = moment(
          getSingleRequest.trRequest.startMasterUsePeriod
        ).format("YYYY-MM-DD");
        initialValues.endDatePeriod = moment(
          getSingleRequest.trRequest.endMasterUsePeriod
        ).format("YYYY-MM-DD");
      }

      setValidationDocumentType(getSingleRequest.trRequest.documentTypeID);
      setGlobalDocumentType(getSingleRequest.trRequest.documentTypeID);
      // case Hard Copy
      if (
        getSingleRequest.trRequest.documentTypeID ==
        DocumentType.toId(DocumentType.Hardcopy)
      ) {
        initialValues.area = getSingleRequest.trRequest.area;
        initialValues.address = getSingleRequest.trRequest.detailArea;
      }

      const filteredJustMultiUpload = getSingleRequest.trDocument.filter(
        (item) =>
          item.category !== "Hardcopy SK" &&
          item.category !== "Master Document Realization"
      );
      const transformedData = transformSingleData(filteredJustMultiUpload);
      if (transformedData.length == 2) {
        const newItem: NewIDataUploadItem = {
          title: "Unggah Permohonan Partner / Upload Partner Request",
          fileType: "Partner Request",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        };
        transformedData.push(newItem);
      }

      const transformedDataRealization = transformSingleData(
        getSingleRequest.trDocument.filter(
          (item) => item.category == "Master Document Realization"
        )
      );
      if (transformedDataRealization.length > 0) {
        setUploadRealizationDM(transformedDataRealization);
      }

      setDataUpload(transformedData);

      if (getSingleRequest.trComment.length > 0) {
        const filteredCommentEnduser = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000002"
        );
        setDataCommentEndUser(filteredCommentEnduser);

        const filteredCommentCL = getSingleRequest.trComment.filter(
          (item) => item.toRole === "RL230000003"
        );
        setDataCommentCL(filteredCommentCL);
      }

      if (getSingleRequest.trRequest.requestTypeID !== null) {
        initialValues.requestType = getSingleRequest.trRequest.requestTypeID;
        setValidationRequestType(getSingleRequest.trRequest.requestTypeID);
      }

      if (
        getSingleRequest.trRequest.signer == "Tidak ada~Tidak ada#Tidak ada"
      ) {
        initialValues.delegatee = {
          name: "Tidak ada",
          binusianIDEmail: "Tidak ada~Tidak ada",
        };
        initialValues.substitutor = {
          name: "Tidak ada",
          binusianIDEmail: "Tidak ada~Tidak ada",
        };
      }

      if (getSingleRequest.trRequest.delegatee != null) {
        initialValues.delegatee = {
          binusianIDEmail: getSingleRequest.trRequest.delegatee.split("#")[0],
          name: getSingleRequest.trRequest.delegatee.split("#")[1],
        };
      }

      if (getSingleRequest.trRequest.substitutor != null) {
        initialValues.substitutor = {
          binusianIDEmail: getSingleRequest.trRequest.substitutor.split("#")[0],
          name: getSingleRequest.trRequest.substitutor.split("#")[1],
        };
      }
      initialValues.noPowerAttorney = getSingleRequest.trRequest.noPOA;
      initialValues.noSubstitutor = getSingleRequest.trRequest.noSubstitution;
      if (id !== undefined) {
        getBase64GeneratePdfSuratPersetujuanMaster(
          id,
          `Surat Persetujuan Penggunaan Master Dokumen_${moment(
            getSingleRequest.finishedDate
          ).format("DDMMYYYY")}.pdf`
        ).then((res) =>
          setFileSuratPersetujuanGeneratePdf((prev) => {
            const data: NewIDataUploadItem = {
              ...prev[0],
              files: [
                {
                  ...prev[0].files[0],
                  documentID: res,
                  fileName: `Surat Persetujuan Penggunaan Master Dokumen_${moment(
                    getSingleRequest.finishedDate
                  ).format("DDMMYYYY")}.pdf`,
                  fileBase64: res,
                },
              ],
            };
            return [data];
          })
        );
      }

      const dbCRR = getSingleRequest.trRequest.noCRR;
      setCrrNumber(dbCRR);
      const realizationValidation =
        getSingleRequest?.trRequest?.needRealization?.toString() ?? "false";
      initialValues.needRealization = realizationValidation;
      if (realizationValidation == "false") {
        setValidationNeedRealization(true);
      }
    } catch (error) {
      // Handle error if needed
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const firstLoad = async () => {
      setLoadingActive(true);
      await getDocumentType();
      await getAreaLocation();
      await getRequestType();
      if (id !== undefined) {
        // get api data
        await getSingleData();
        setValueTab(1);
      }
      setLoadingActive(false);
    };
    firstLoad();
  }, []);

  const validation = (values: IForm) => {
    const errors: FormikErrors<IForm | undefined> = {};
    if (values.dateOfPower === "") {
      errors.dateOfPower = "Date of Power of Attorney must be filled";
    }
    if (
      values.startDatePeriod === "" &&
      validationRequestType === RequestType.toId(RequestType.DokumenMaster)
    ) {
      errors.startDatePeriod = "Start Date Period must be filled";
    }
    if (
      values.endDatePeriod === "" &&
      validationRequestType === RequestType.toId(RequestType.DokumenMaster)
    ) {
      errors.endDatePeriod = "End Date Period must be filled";
    }
    if (
      values.startDatePeriod !== "" &&
      values.endDatePeriod !== "" &&
      values.endDatePeriod < values.startDatePeriod &&
      validationRequestType === RequestType.toId(RequestType.DokumenMaster)
    ) {
      errors.endDatePeriod = "End Date must not be earlier than Start Date";
    }
    if (values.titleAgreement === "") {
      errors.titleAgreement = "Title of Agreement must be filled";
    }
    if (
      values.address === "" &&
      values.documentType == DocumentType.toId(DocumentType.Hardcopy)
    ) {
      errors.address = "Address must be filled";
    }
    if (values.counterPart === "") {
      errors.counterPart = "Counterpart must be filled";
    }
    if (values.signer === null) {
      errors.signer = "Signer must be filled";
    }
    if (
      (values.delegatee === null &&
        validationRequestType == RequestType.toId(RequestType.SuratKuasa)) ||
      (values.delegatee === null &&
        validationRequestType == RequestType.toId(RequestType.DokumenMaster) &&
        validationSignerAndLeader == false)
    ) {
      errors.delegatee = "Delegatee must be filled";
    }

    const checkFileRequired = dataUpload.some(
      (item) =>
        item.title.includes("*") &&
        item.files.some((file) => file.fileName === "")
    );
    if (checkFileRequired) {
      setErrorUpload("Please upload required file");
    } else {
      setErrorUpload("");
    }

    if (
      uploadRealizationDM[0].files.some((file) => file.fileName === "") &&
      validationRequestType == RequestType.toId(RequestType.DokumenMaster) &&
      !validationNeedRealization
    ) {
      setErrorUploadRealizationDM("Please upload Master Document Realization");
    } else {
      setErrorUploadRealizationDM("");
    }

    return errors;
  };

  const onSubmitForm = async (values: IForm) => {
    const updatedValues = { ...values };
    if (
      validationRequestType == RequestType.toId(RequestType.DokumenMaster) &&
      validationSignerAndLeader == true
    ) {
      updatedValues.delegatee = null;
      updatedValues.substitutor = null;
      setRequestStatusID(RequestStatus.toId(RequestStatus.Finished));
    } else {
      setRequestStatusID(
        RequestStatus.toId(RequestStatus.AwaitingConfirmation)
      );
    }

    if (validationDocumentType == DocumentType.toId(DocumentType.Softcopy)) {
      updatedValues.area = "-";
      updatedValues.address = "-";
    }
    if (validationRequestType == RequestType.toId(RequestType.SuratKuasa)) {
      updatedValues.startDatePeriod = "";
      updatedValues.endDatePeriod = "";
      const resetUploadRealizationDM = [
        {
          title:
            "Unggah Realisasi Dokumen Master / Upload Master Document Realization*",
          fileType: "Master Document Realization",
          files: [
            { documentID: "", fileBase64: "", fileName: "", folderName: "" },
          ],
        },
      ];
      setUploadRealizationDM(resetUploadRealizationDM);
    }

    setFormData(updatedValues);

    if (
      errorUpload == "" &&
      (validationNeedRealization || errorUploadRealizationDM == "") &&
      crrNumber.length <= 12
    ) {
      if (
        updatedValues.needSK == "true" &&
        updatedValues.requestType ==
          RequestType.toId(RequestType.DokumenMaster) &&
        (actionButtonClick == "saveAndSend" || actionButtonClick == "resend")
      ) {
        if (actionButtonClick == "saveAndSend")
          setSaveAndSendConfirmationSubmit(true);
        else if (actionButtonClick == "resend")
          setResendConfirmationSubmit(true);
      } else {
        setOpenConfirmationSubmit(true);
      }
    }
  };

  const handleSubmit = async () => {
    let isSuccessful = false;
    setOpenConfirmationSubmit(false);
    setLoadingActive(true);

    if (actionButtonClick === "resend") {
      const submit = await resendEmailFinishedForm(
        id,
        resendConfirmationValue !== ""
          ? resendConfirmationValue
          : formData?.requestType == RequestType.toId(RequestType.SuratKuasa)
          ? "SK"
          : "DM"
      );

      setLoadingActive(false);
      if (submit.resultCode === 200) {
        setFeedbackText("Email has been resent successfully!");
        setFeedbackType("success");
        setOpenFeedback(true);
        isSuccessful = true;
      } else {
        setFeedbackText(submit.errorMessage || "Failed to resend email");
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    } else {
      const submit = await editFormFinishCL(
        formData,
        uploadRealizationDM,
        id,
        requestStatusID,
        crrNumber,
        actionButtonClick,
        saveAndSendConfirmationValue !== ""
          ? saveAndSendConfirmationValue
          : formData?.requestType == RequestType.toId(RequestType.SuratKuasa)
          ? "SK"
          : "DM"
      );
      setLoadingActive(false);
      if (submit.resultCode === 200) {
        setFeedbackText("Your data has been successfully saved!");
        setFeedbackType("success");
        setOpenFeedback(true);
        isSuccessful = true;
      } else {
        setFeedbackText(submit.errorMessage);
        setFeedbackType("failed");
        setOpenFeedback(true);
      }
    }

    if (isSuccessful) {
      setTimeout(() => {
        Navigate("/");
      }, 3000);
    }
  };

  const onResetForm = () => {
    setValidationDocumentType(globalDocumentType);
  };

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChangeUpload = async (type, data, dataIndex, fileIndex) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);

      if (type == "multi") {
        // multi untuk upload data yg looping, kalo single untuk upload file satuan
        const newDataUpload = [...dataUpload];
        const filteredSameFileName = !newDataUpload.some((item) =>
          item.files.some((file) => {
            const existingFileNameWithoutDate = RemoveDateFromFileName(
              file.fileName
            );
            return existingFileNameWithoutDate === newFileNameWithoutDate;
          })
        );
        if (filteredSameFileName) {
          newDataUpload[dataIndex] = {
            title: newDataUpload[dataIndex].title,
            fileType: newDataUpload[dataIndex].fileType,
            files: [...newDataUpload[dataIndex].files],
          };
          newDataUpload[dataIndex].files[fileIndex] = {
            documentID: "",
            fileBase64: resultBase64File,
            fileName: data.name,
            folderName: "",
          };
          setDataUpload(newDataUpload);
          if (
            newDataUpload[dataIndex].title.includes("*") &&
            newDataUpload[dataIndex].files[fileIndex].fileBase64 != ""
          ) {
            setErrorUpload("");
          }
        } else {
          setFeedbackText(
            "The file already exists, please change the file name"
          );
          setFeedbackType("failed");
          setOpenFeedback(true);
          setTimeout(() => {
            setOpenFeedback(false);
          }, 2000);
        }
      } else {
        const filteredSameName = !uploadRealizationDM[0].files.some((file) => {
          const existingFileNameWithoutDate = RemoveDateFromFileName(
            file.fileName
          );
          return existingFileNameWithoutDate === newFileNameWithoutDate;
        });
        if (filteredSameName) {
          const newUploadRealizationDM: NewIDataUploadItem = {
            title: uploadRealizationDM[0].title,
            fileType: uploadRealizationDM[0].fileType,
            files: [...uploadRealizationDM[0].files],
          };
          newUploadRealizationDM.files[fileIndex] = {
            documentID: "",
            fileBase64: resultBase64File,
            fileName: data.name,
            folderName: "",
          };
          setUploadRealizationDM([newUploadRealizationDM]);
          setErrorUploadRealizationDM("");
        } else {
          setFeedbackText(
            "The file already exists, please change the file name"
          );
          setFeedbackType("failed");
          setOpenFeedback(true);
          setTimeout(() => {
            setOpenFeedback(false);
          }, 2000);
        }
      }
    }
  };

  const handleChangeDelete = (type, dataIndex, fileIndex) => {
    if (type == "multi") {
      // multi untuk upload data yg looping, kalo single untuk upload file satuan
      const newDataUpload = [...dataUpload];
      newDataUpload[dataIndex].files[fileIndex] = {
        documentID: "",
        fileBase64: "",
        fileName: "",
        folderName: "",
      };
      setDataUpload(newDataUpload);
      if (
        newDataUpload[dataIndex].title.includes("*") &&
        newDataUpload[dataIndex].files[fileIndex].fileBase64 == ""
      ) {
        setErrorUpload("Please upload required file");
      }
    } else {
      const newUploadRealizationDM = uploadRealizationDM;
      newUploadRealizationDM[0].files[fileIndex] = {
        documentID: "",
        fileBase64: "",
        fileName: "",
        folderName: "",
      };
      setUploadRealizationDM(newUploadRealizationDM);
      setErrorUploadRealizationDM("Please upload Master Document Realization");
    }
  };

  const handleChangeDownload = async (type, dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");

    // eslint-disable-next-line unicorn/consistent-function-scoping, consistent-return
    const downloadFile = async () => {
      try {
        // get all data for table list User
        const currentTime: any = new Date();
        const differenceInMinutesTokenSharepoint: any =
          (sharepoint.expToken - currentTime) / 1000 / 60;

        if (differenceInMinutesTokenSharepoint < 10) {
          const tokenSharepoint = await getSharepointToken();

          setSharepoint({
            ...sharepoint,
            token: tokenSharepoint.token,
            expToken: new Date(currentTime.getTime() + 30 * 60 * 1000),
          });
          // lakukan download
          if (type == "multi") {
            const getBase64Download = await downloadSingleFile(
              getDataUpload[dataIndex].files[fileIndex].fileName,
              getDataUpload[dataIndex].fileType,
              id,
              tokenSharepoint.token
            );
            return getBase64Download;
          }
          const getBase64Download = await downloadSingleFile(
            uploadRealizationDM[0].files[fileIndex].fileName,
            uploadRealizationDM[0].fileType,
            id,
            tokenSharepoint.token
          );
          return getBase64Download;
        }
        // eslint-disable-next-line no-else-return
        else {
          if (type == "multi") {
            const getBase64Download = await downloadSingleFile(
              getDataUpload[dataIndex].files[fileIndex].fileName,
              getDataUpload[dataIndex].fileType,
              id,
              sharepoint.token
            );
            return getBase64Download;
          }
          const getBase64Download = await downloadSingleFile(
            uploadRealizationDM[0].files[fileIndex].fileName,
            uploadRealizationDM[0].fileType,
            id,
            sharepoint.token
          );
          return getBase64Download;
        }
      } catch (error) {
        // Handle error if needed
        console.log("Error fetching data:", error);
      }
    };

    setLoadingActive(true);
    const tempBase64File = await downloadFile();
    setLoadingActive(false);
    if (type == "multi") {
      if (getDataUpload[dataIndex].files[fileIndex].documentID != "") {
        getDataUpload[dataIndex].files[fileIndex].fileBase64 = tempBase64File;
      }
      if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
        downloadLink.href =
          getDataUpload[dataIndex].files[fileIndex].fileBase64;
        downloadLink.download =
          getDataUpload[dataIndex].files[fileIndex].fileName;
        downloadLink.click();
      }
    } else {
      if (uploadRealizationDM[0].files[fileIndex].documentID != "") {
        uploadRealizationDM[0].files[fileIndex].fileBase64 = tempBase64File;
      }
      if (uploadRealizationDM[0].files[fileIndex].fileBase64 != "") {
        downloadLink.href = uploadRealizationDM[0].files[fileIndex].fileBase64;
        downloadLink.download =
          uploadRealizationDM[0].files[fileIndex].fileName;
        downloadLink.click();
      }
    }
  };

  const handleDownloadSuratPersetujuanGeneratePdf = async (
    type,
    dataIndex,
    fileIndex
  ) => {
    const getDataUpload = [...fileSuratPersetujuanGeneratePdf];
    const downloadLink = document.createElement("a");

    const { fileName } = getDataUpload[0].files[fileIndex];
    setLoadingActive(true);
    const getBase64PdfSuratPersetujuan =
      await getBase64GeneratePdfSuratPersetujuanMaster(id, fileName);
    setLoadingActive(false);
    downloadLink.download = fileName;
    downloadLink.href = getBase64PdfSuratPersetujuan;

    downloadLink.click();
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px", padding: 0, margin: 0 }}>
        <div className="tabs-container">
          Home {">"} {requestStatusName}
        </div>
        <div className="tabs-container">
          <hr style={{ color: "black", width: "100%" }} />
        </div>
      </Box>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              No. Request / <i>Request Number</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "250px" }}
          >
            <b>{requestNumber}</b>
          </Typography>
        </div>
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <div style={{ display: "flex" }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ marginLeft: "23px", width: "300px" }}
          >
            <b>
              Tanggal Permintaan / <i>Request Date</i>
            </b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "15px" }}
          >
            <b>:</b>
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ width: "200px" }}
          >
            <b>{requestDate}</b>
          </Typography>
        </div>
      </Grid>
      <CRRNumberField
        crrNumber={crrNumber}
        crrNumError=""
        isDisabled
        onCRRChange={() => {}}
      />
      <div className="tabs-container" style={{ marginTop: "1.5%" }}>
        <Tabs value={valueTab} onChange={handleChangeTab} textColor="primary">
          <Tab
            style={{ color: valueTab === 0 ? "#fff" : "#000" }}
            color="primary"
            label="Data Diri / Profile"
            className={valueTab === 0 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 1 ? "#fff" : "#000" }}
            color="primary"
            label="Permohonan Detil / Detail Request"
            className={valueTab === 1 ? "active-tab-panel" : "hidden-tab-panel"}
          />

          <Tab
            style={{ color: valueTab === 2 ? "#fff" : "#000" }}
            color="primary"
            label="Workflow"
            className={valueTab === 2 ? "active-tab-panel" : "hidden-tab-panel"}
          />
        </Tabs>
      </div>
      <div className="tabs-container">
        <hr className="tab-line" />
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmitForm}
        validate={validation}
        onReset={onResetForm}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <TabPanel value={valueTab} index={0}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Pemohon / <i>Applicant</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="binusianName"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jabatan / <i>Title</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent propsData={props} name="title" />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Divisi / <i>Business Unit</i>
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="businessUnit"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "25px" }}
                    gutterBottom
                  >
                    <u>Business Unit Leader</u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="buLeader"
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Department / <i>Department</i>
                    </u>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="department"
                  />
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "40px" }}
                    gutterBottom
                  >
                    <u>
                      Ekstensi / <i>Extension</i> (Ext.)
                    </u>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="extension"
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  Next Page {">>"}
                </Button>
              </Box>
            </TabPanel>
            <TabPanel value={valueTab} index={1}>
              <Grid container spacing={3}>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Tanggal Surat Kuasa / <i>Date of Power of Attorney </i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateDisabledComponent
                    propsData={props}
                    name="dateOfPower"
                  />
                  {props.errors.dateOfPower && (
                    <div className="error-message">
                      {props.errors.dateOfPower}
                    </div>
                  )}

                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Pihak Penandatangan / <i>Signer</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <AutocompleteDisabledComponent
                    propsData={props}
                    name="signer"
                  />
                  {props.errors.signer && (
                    <div className="error-message">{props.errors.signer}</div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontSize: "0.98rem" }}
                    gutterBottom
                  >
                    <u>
                      Tanggal Pemberian Surat Kuasa /{" "}
                      <i>Date of Granting of Power of Attorney</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDateDisabledComponent
                    propsData={props}
                    name="dateGrantOfPower"
                  />
                  {props.errors.dateGrantOfPower && (
                    <div className="error-message">
                      {props.errors.dateGrantOfPower}
                    </div>
                  )}
                  <Typography
                    variant="subtitle1"
                    style={{
                      paddingTop: "20px",
                    }}
                    gutterBottom
                  >
                    <u>
                      Catatan Legal / <i>Legal Notes</i>
                    </u>
                  </Typography>
                  <Grid item lg={12} md={12} xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Corporate Legal:
                    </Typography>
                    <TextAreaDisabledComponent
                      propsData={props}
                      name="clNote"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      Legal Relation:
                    </Typography>
                    <TextAreaDisabledComponent
                      propsData={props}
                      name="lrNote"
                    />
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Judul Perjanjian / <i>Title of Agreement</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldMultiDisabledComponent
                    propsData={props}
                    name="titleAgreement"
                  />
                  {props.errors.titleAgreement && (
                    <div className="error-message">
                      {props.errors.titleAgreement}
                    </div>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Partner / <i>Counterpart</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <TextFieldDisabledComponent
                    propsData={props}
                    name="counterPart"
                  />
                  {props.errors.counterPart && (
                    <div className="error-message">
                      {props.errors.counterPart}
                    </div>
                  )}
                  <Typography
                    variant="subtitle1"
                    style={{ paddingTop: "20px" }}
                    gutterBottom
                  >
                    <u>
                      Jenis Dokumen / <i>Document Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistDisabledComponent
                    propsData={props}
                    name="documentType"
                    ddlData={listDocumentType}
                  />
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {dataUpload.map((obj, i) => (
                    <div>
                      <UploadMultipleFileComponent
                        disabled
                        file={obj}
                        fileIndex={i}
                        onUploadFile={(data, fileIndex) => {
                          handleChangeUpload("multi", data, i, fileIndex);
                        }}
                        onDeleteFile={(fileIndex) =>
                          handleChangeDelete("multi", i, fileIndex)
                        }
                        onAddMoreData={() => {
                          if (dataUpload[i].files.length < 5) {
                            setDataUpload((prevState) => {
                              const newState = [...prevState];
                              const emptyFile = {
                                documentID: "",
                                fileBase64: "",
                                fileName: "",
                                folderName: "",
                              };
                              if (i >= 0 && i < newState.length) {
                                newState[i].files.push(emptyFile);
                              }

                              return newState;
                            });
                          }
                        }}
                        onDeleteData={(ind) => {
                          setDataUpload((prevState) => {
                            const newState = [...prevState];
                            if (
                              i >= 0 &&
                              i < newState.length &&
                              ind >= 0 &&
                              ind < newState[i].files.length
                            ) {
                              newState[i].files.splice(ind, 1);
                            }

                            return newState;
                          });
                        }}
                        onDownloadFile={(fileIndex) => {
                          handleChangeDownload("multi", i, fileIndex);
                        }}
                        requiredValidationMessage={errorUpload}
                      />
                    </div>
                  ))}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  {validationDocumentType ==
                    DocumentType.toId(DocumentType.Hardcopy) && (
                    <div style={{ paddingBottom: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Lokasi / <i>Area</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <DropdownlistDisabledComponent
                        propsData={props}
                        name="area"
                        ddlData={listAreaLocation}
                      />
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        style={{ paddingTop: "20px" }}
                      >
                        <u>
                          Ruang / <i>Room</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldMultiDisabledComponent
                        propsData={props}
                        name="address"
                      />
                      {props.errors.address && (
                        <div className="error-message">
                          {props.errors.address}
                        </div>
                      )}
                    </div>
                  )}
                  {validationRequestType ==
                    RequestType.toId(RequestType.DokumenMaster) && (
                    <>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Periode Penggunaan (Khusus Dokumen Master) /{" "}
                          <i>Period of Use (Master Document only)</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <Grid container spacing={3} item md={12} xs={12}>
                        <Grid item md={6} xs={6}>
                          <TextFieldDateComponent
                            propsData={props}
                            name="startDatePeriod"
                          />
                          {props.errors.startDatePeriod && (
                            <div className="error-message">
                              {props.errors.startDatePeriod}
                            </div>
                          )}
                        </Grid>
                        <Grid item md={6} xs={6}>
                          <TextFieldDateComponent
                            propsData={props}
                            name="endDatePeriod"
                          />
                          {props.errors.endDatePeriod && (
                            <div className="error-message">
                              {props.errors.endDatePeriod}
                            </div>
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid item lg={6} md={12} xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    <u>
                      Jenis Permohonan / <i>Request Type</i>
                    </u>
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <DropdownlistDisabledComponent
                    propsData={props}
                    name="requestType"
                    ddlData={listRequestType}
                  />
                </Grid>
                {validationRequestType ==
                RequestType.toId(RequestType.DokumenMaster) ? (
                  <Grid item lg={6} md={12} xs={12}>
                    {!validationNeedRealization &&
                      uploadRealizationDM.map((obj, i) => (
                        <div>
                          <UploadMultipleFileComponent
                            file={obj}
                            fileIndex={i}
                            onUploadFile={(data, fileIndex) => {
                              handleChangeUpload("single", data, i, fileIndex);
                            }}
                            onDeleteFile={(fileIndex) =>
                              handleChangeDelete("single", i, fileIndex)
                            }
                            onAddMoreData={() => {
                              if (uploadRealizationDM[i].files.length < 5) {
                                setUploadRealizationDM((prevState) => {
                                  const newState = [...prevState];
                                  const emptyFile = {
                                    documentID: "",
                                    fileBase64: "",
                                    fileName: "",
                                    folderName: "",
                                  };
                                  if (i >= 0 && i < newState.length) {
                                    newState[i].files.push(emptyFile);
                                  }

                                  return newState;
                                });
                              }
                            }}
                            onDeleteData={(ind) => {
                              setUploadRealizationDM((prevState) => {
                                const newState = [...prevState];
                                if (
                                  i >= 0 &&
                                  i < newState.length &&
                                  ind >= 0 &&
                                  ind < newState[i].files.length
                                ) {
                                  newState[i].files.splice(ind, 1);
                                }

                                return newState;
                              });
                            }}
                            onDownloadFile={(fileIndex) => {
                              handleChangeDownload("single", i, fileIndex);
                            }}
                            requiredValidationMessage={errorUploadRealizationDM}
                          />
                        </div>
                      ))}
                    {fileSuratPersetujuanGeneratePdf.map((obj, i) => (
                      <div>
                        <UploadMultipleFileComponent
                          disabled
                          file={obj}
                          fileIndex={i}
                          onUploadFile={() => {}}
                          onDeleteFile={() => {}}
                          onAddMoreData={() => {}}
                          onDeleteData={() => {}}
                          onDownloadFile={(fileIndex) => {
                            handleDownloadSuratPersetujuanGeneratePdf(
                              "single",
                              i,
                              fileIndex
                            );
                          }}
                          requiredValidationMessage=""
                        />
                      </div>
                    ))}
                  </Grid>
                ) : (
                  <Grid item lg={6} md={12} xs={12} />
                )}
                {(validationRequestType ==
                  RequestType.toId(RequestType.SuratKuasa) ||
                  (validationRequestType ==
                    RequestType.toId(RequestType.DokumenMaster) &&
                    validationSignerAndLeader == false)) && (
                  <>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Penerima Kuasa / <i>Delegatee</i>
                        </u>
                      </Typography>
                      <AutocompleteDisabledComponent
                        propsData={props}
                        name="delegatee"
                      />
                      {props.errors.delegatee && (
                        <div className="error-message">
                          {props.errors.delegatee}
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          Subtitusi /<i>Substitutor</i>
                        </u>
                      </Typography>
                      <AutocompleteDisabledComponent
                        propsData={props}
                        name="substitutor"
                      />
                      {props.errors.substitutor && (
                        <div className="error-message">
                          {props.errors.substitutor}
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          No. Surat Kuasa / <i> Number of Power of Attorney</i>
                        </u>
                        <span style={{ color: "red" }}> *</span>
                      </Typography>
                      <TextFieldDisabledComponent
                        propsData={props}
                        name="noPowerAttorney"
                      />
                      {props.errors.noPowerAttorney && (
                        <div className="error-message">
                          {props.errors.noPowerAttorney}
                        </div>
                      )}
                    </Grid>
                    <Grid item lg={6} md={12} xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        <u>
                          No. Surat Substitusi /{" "}
                          <i> Number of Substitution Letter</i>
                        </u>
                      </Typography>
                      <TextFieldDisabledComponent
                        propsData={props}
                        name="noSubstitutor"
                      />
                      {props.errors.noSubstitutor && (
                        <div className="error-message">
                          {props.errors.noSubstitutor}
                        </div>
                      )}
                    </Grid>
                  </>
                )}
              </Grid>

              <Grid container justifyContent="center" sx={{ mt: 2 }}>
                <Button
                  variant="outlined"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => setActionButtonClick("save")}
                  type="submit"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => setActionButtonClick("saveAndSend")}
                  type="submit"
                >
                  Save & Send
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    m: 1,
                    width: "150px",
                    textTransform: "none",
                    fontWeight: "bold",
                  }}
                  onClick={() => setActionButtonClick("resend")}
                  type="submit"
                >
                  Resend
                </Button>
              </Grid>

              {dataCommentEndUser.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Komentar / <i>Comments for Requestor</i>
                    <hr />
                  </Box>
                  {dataCommentEndUser.map((obj, i) => (
                    <CommentDisabledComponent
                      allObj={{ ...obj, requestNumber }}
                      key={obj.commentID}
                    />
                  ))}
                </>
              )}

              {dataCommentCL.length > 0 && (
                <>
                  <Box sx={{ fontSize: "25px", marginTop: "3%" }}>
                    Komentar / <i>Comments for Corporate Legal</i>
                    <hr />
                  </Box>
                  {dataCommentCL.map((obj, i) => (
                    <CommentDisabledComponent
                      allObj={{ ...obj, requestNumber }}
                      key={obj.commentID}
                    />
                  ))}
                </>
              )}

              <Box
                sx={{
                  display: "flex",
                  paddingTop: "20px",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(0)}
                >
                  {"<<"} Previous Page
                </Button>
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(2)}
                >
                  {">>"} Next Page
                </Button>
              </Box>

              <ConfirmationDialog
                open={openConfirmationSubmit}
                title="Confirmation"
                message="Are you sure you want to proceed ?"
                onConfirm={() => {
                  handleSubmit();
                }}
                onCancel={() => {
                  setOpenConfirmationSubmit(false);
                }}
              />
              <Dialog
                open={saveAndSendConfirmationSubmit}
                onClose={() => {
                  setSaveAndSendConfirmationSubmit(false);
                  setSaveAndSendConfirmationValue("");
                }}
              >
                <form onSubmit={() => setOpenConfirmationSubmit(true)}>
                  <DialogContent>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={saveAndSendConfirmationValue}
                        onChange={(e) =>
                          setSaveAndSendConfirmationValue(e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="SK"
                          control={<Radio />}
                          label="Send Surat Kuasa Only"
                        />
                        <FormControlLabel
                          value="DM"
                          control={<Radio />}
                          label="Send Dokumen Master Only"
                        />
                        <FormControlLabel
                          value="DMSK"
                          control={<Radio />}
                          label="Send Dokumen Master with Surat Kuasa"
                        />
                      </RadioGroup>
                    </FormControl>
                  </DialogContent>
                  <DialogActions
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color={
                        saveAndSendConfirmationValue == ""
                          ? "secondary"
                          : "primary"
                      }
                      disabled={saveAndSendConfirmationValue == ""}
                      style={{ textTransform: "capitalize" }}
                    >
                      Send Email
                    </Button>
                  </DialogActions>
                </form>
              </Dialog>
              <Dialog
                open={resendConfirmationSubmit}
                onClose={() => {
                  setResendConfirmationSubmit(false);
                  setResendConfirmationValue("");
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setResendConfirmationSubmit(false);
                  }}
                >
                  <DialogContent>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={resendConfirmationValue}
                        onChange={(e) =>
                          setResendConfirmationValue(e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="SK"
                          control={<Radio />}
                          label="Resend Surat Kuasa Only"
                        />
                        <FormControlLabel
                          value="DM"
                          control={<Radio />}
                          label="Resend Dokumen Master Only"
                        />
                        <FormControlLabel
                          value="DMSK"
                          control={<Radio />}
                          label="Resend Dokumen Master with Surat Kuasa"
                        />
                      </RadioGroup>
                    </FormControl>
                  </DialogContent>

                  <DialogActions
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        setResendConfirmationSubmit(false);
                      }}
                      type="button"
                      variant="contained"
                      color={
                        resendConfirmationValue == "" ? "secondary" : "primary"
                      }
                      disabled={resendConfirmationValue == ""}
                      style={{ textTransform: "capitalize" }}
                    >
                      Resend Email
                    </Button>
                  </DialogActions>
                </form>
              </Dialog>
            </TabPanel>
            <TabPanel value={valueTab} index={2}>
              <TransactionHistoryModal />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  paddingTop: "20px",
                }}
              >
                <Button
                  style={{ textTransform: "none", padding: "0", color: "blue" }}
                  variant="text"
                  onClick={() => setValueTab(1)}
                >
                  {"<<"} Previous Page
                </Button>
              </Box>
            </TabPanel>
            <Loading open={loadingActive} />
            <Feedback
              open={openFeedback}
              message={feedbackText}
              feedbackType={feedbackType}
              onClose={() => {
                if (feedbackType == "failed") {
                  setOpenFeedback(false);
                }
              }}
            />
          </form>
        )}
      </Formik>
    </Container>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export default EditFinishCL;
